import { Component, OnInit } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { CookieService } from 'ngx-cookie';

@Component({
  selector: 'main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  sliders: any[];

  msgs: any[];

  badges: any[];

  constructor(private snackBar: MdSnackBar, private _cookieService:CookieService) {

    this.msgs = [];
    this.sliders = [
        {
          name: 'slider-1',
          header: 'Nanopharmacia Diagnóstica es el laboratorio en análisis genéticos y genómicos de alta especialidad encológica líder en México y America Latina'
        }
    ];

    this.badges = [
        {
          innovation: 'red',
          service: 'red',
          integrity: 'red',
          excellence: 'red',
        }
    ];
  }

  openSnackBar(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 12000,
    });
    snackBarRef.onAction().subscribe(() => {
      this._cookieService.put('dialog', 'true');
    });
  }

  ngOnInit() {
    if(!this._cookieService.get('dialog')) {
      this.openSnackBar("El contenido del sitio web www.nanopharmacia.com, como texto, gráficos, imágenes y otros materiales contenidos en el sitio web de Nanopharmacia ('el contenido') son sólo para fines informativos. El Contenido no pretende ser un sustituto del asesoramiento, diagnóstico o tratamiento médico profesional. Siempre busque el consejo de su médico u otro proveedor de salud calificado con cualquier pregunta que pueda tener con respecto a una condición médica. Nunca ignore el consejo médico profesional o demore en buscarlo debido a algo que ha leído en el sitio web www.nanopharmacia.com","Aceptar");
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts